import get from 'lodash/get';
import { isEmpty } from 'lodash';
import { emptyQuery } from '../AdvancedSearch/QueryBuilder/constants';

// Configuration Batch Update list
export const selectChosenChargersConfigurationUpdate = (state) => get(state, 'ssplists.configurationBatchUpdate.selectedDataIds', []);
export const selectSelectAllConfigurationUpdate = (state) => get(state, 'ssplists.configurationBatchUpdate.selectAll', false);

// FW Updates
export const selectFWUpdatesById = (id) => (state) => {
  const data = get(state, 'ssplists.firmwareUpdate.data', []);

  return data.find((charger) => charger.c_uuid === id);
};

export const selectSsplistsQuery = (id) => (state) => get(state.ssplists, [id, 'filterQuery']);
export const selectIsExistSimpleFilter = (id) => (state) => !isEmpty(get(state.ssplists, `${id}.filter`));
export const selectAppliedFilter = (id) => (state) => get(state.ssplists, [id, 'appliedQuery'], emptyQuery);
export const selectIsFilterApplied = (id) => (state) => !isEmpty(get(state.ssplists, `${id}.appliedQuery.rules`));
export const selectSspListStateById = (id) => (state) => get(state, ['ssplists', id]);
